document.addEventListener("DOMContentLoaded", function () {

    // Hide filters
    const menuClose = document.getElementById("mobileFiltersClose");
    const menuOpen = document.getElementById("open-mobile-filters");
    const mobileMenu = document.getElementById("mobile-filters");
    const body = document.querySelector("body");

    menuClose.addEventListener("click", function () {
        closeMenu();
    });

    menuOpen.addEventListener("click", function () {
        openMenu();
    });

    function closeMenu() {
        mobileMenu.classList.remove("translate-x-0");
        body.classList.remove("overflow-hidden")
    }

    function openMenu() {
        mobileMenu.classList.add("translate-x-0");
        body.classList.add("overflow-hidden")
    }

    // Get all menu items
    const menuItems = document.querySelectorAll('#mobile-filters .filter-group-summary');
    const displayItems = document.querySelectorAll('#mobile-filters  .filter-group-display');

    // Add a click event listener to each menu item
    menuItems.forEach((menuItem) => {
        menuItem.addEventListener('click', toggleSubMenu);
    });

    function toggleSubMenu(event) {
        const menuItem = event.target;
        const filterGroup = menuItem.closest('.filter-group')
        const submenu = filterGroup.querySelector('.filter-group-display');

        displayItems.forEach((disItem) => {
            disItem.style.display = 'none';
        });

        if (submenu) {
            submenu.style.display = (submenu.style.display === 'block') ? 'none' : 'flex';
        }
    }

    const mobileFilterCloseButtons = document.querySelectorAll('.mobileFiltersClose');
    const mobileFilterPanels = document.querySelectorAll('.filter-group-display ');

    mobileFilterCloseButtons.forEach((panelClose) => {
        panelClose.addEventListener('click', closePanels );
    });

    function closePanels() {
        mobileFilterPanels.forEach((panel) => {
            panel.style.display = 'none';
        });
    }
});

